$(window).on("load", function () {
  if ($(window).outerWidth() < 1280) return;

  if ($("div.sidebar").length && $(".product-description-wrap").length) {
    const asideEdge =
      $("div.sidebar").offset().top +
      $("div.sidebar").outerHeight() -
      $("aside.sidebar").offset().top -
      $("aside.sidebar").outerHeight();

    $(".product-description-wrap").css({ "min-height": `${Math.round(asideEdge)}px` });
  }
});

if ($(".product-buy-card").length) {
  $(".product-buy-card").css({
    "--w": `${$(".product-buy-card").outerWidth()}px`,
    "--or": `${$(window).width() - ($(".product-buy-card").offset().left + $(".product-buy-card").outerWidth())}px`,
  });

  $(window).on("resize", function () {
    $(".product-buy-card").css({
      "--w": `${$(".product-buy-card").outerWidth()}px`,
      "--or": `${$(window).width() - ($(".product-buy-card").offset().left + $(".product-buy-card").outerWidth())}px`,
    });
  });
}

$(window).on("scroll", function () {
  if ($(window).outerWidth > 1279) return;
  if (!$(".brand-block").lenght) return;

  const top = $(".brand-block").offset().top + $(".brand-block").outerHeight() - $(window).scrollTop() - 120;

  if (top < 0) {
    $(".cta-holder.wrapper-holder").addClass("is--fixed");
  } else {
    $(".cta-holder.wrapper-holder").removeClass("is--fixed");
  }
});
